import {
  Input,
  Inject,
  OnInit,
  Component,
  Attribute,
  OnDestroy,
  ElementRef,
  AfterViewChecked,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ErrorHandler,
} from '@angular/core';
import {
  MatIcon,
  MatIconLocation,
  MatIconRegistry,
  MAT_ICON_LOCATION,
} from '@angular/material/icon';

import { ISnHasHostElement } from '@lib/common/interfaces';
import { mixinSize } from '@lib/common/mixins';

import { FusuIconService } from '../fusus-icons/service/fusus-icon.service';

class SnBaseIcon extends MatIcon implements ISnHasHostElement {
  public readonly hostElement: HTMLElement;

  constructor(
    elementRef: ElementRef<HTMLElement>,
    iconRegistry: MatIconRegistry,
    ariaHidden: string,
    location: MatIconLocation,
    errorHandler: ErrorHandler,
  ) {
    super(elementRef, iconRegistry, ariaHidden, location, errorHandler);

    this.hostElement = elementRef.nativeElement;
  }
}

const SnBaseIconComponent = mixinSize(SnBaseIcon, { defaultSize: 'md', prefix: 'icon' });

@Component({
  selector: 'sn-icon',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  inputs: ['size', 'inline', 'svgIcon', 'fontSet', 'fontIcon', 'clickable'],
  host: {
    class: 'sn-icon mat-icon ngx-mat-icon',
    '[attr.role]': 'role',
    '[attr.tabindex]': 'tabIndex',
  },
})
export class SnIconComponent
  extends SnBaseIconComponent
  implements AfterViewChecked, OnDestroy, OnInit
{
  @Input()
  public icon: string;

  @Input()
  get fontIconUnicode(): string {
    return this._fontIconUnicode;
  }
  set fontIconUnicode(value: string) {
    this._fontIconUnicode = value ? `&#x${value};` : undefined;
  }

  private _fontIconUnicode: string;

  constructor(
    elementRef: ElementRef<HTMLElement>,
    iconRegistry: MatIconRegistry,
    @Attribute('aria-hidden') ariaHidden: string,
    @Inject(MAT_ICON_LOCATION) location: MatIconLocation,
    private readonly _fususIcon: FusuIconService,
    errorHandler: ErrorHandler,
  ) {
    super(elementRef, iconRegistry, ariaHidden, location, errorHandler);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    if (this.fontSet === 'fs' && !this._fususIcon.isFsFontset(this.fontIcon)) {
      this.fontIconUnicode = this.fontIcon;
      this.fontIcon = null;
      this.fontSet = 'fa';
      this.hostElement.classList.remove('fs');
      this.hostElement.classList.add('fa');
    }
  }

  public ngAfterViewChecked(): void {
    super.ngAfterViewChecked();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public getPath(): any[] {
    return Array(this._fususIcon.getPaths(this.fontIcon).length + 1);
  }
}
